var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ProductCompare = (function (ProductCompare) {

        ProductCompare.Messages = (function (Messages) {

        Messages.Add = function (id, skuId, path, qty) {
            var data = {
                id: id,
                skuId: skuId,
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.ProductCompare.Messages.Add", data);
        };
        Messages.Add.className = "Vendd.ProductCompare.Messages.Add";

        Messages.Remove = function (id) {
            var data = {
                id: id
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.ProductCompare.Messages.Remove", data);
        };
        Messages.Remove.className = "Vendd.ProductCompare.Messages.Remove";

        Messages.Clear = function () {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.ProductCompare.Messages.Clear", null);
        };
        Messages.Clear.className = "Vendd.ProductCompare.Messages.Clear";

        Messages.Changed = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.Changed', null);
        };
        Messages.Changed.className = 'Vendd.ProductCompare.Messages.Changed';

        Messages.GetModel = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.GetModel', null);
        };
        Messages.GetModel.className = 'Vendd.ProductCompare.Messages.GetModel';

        Messages.GetModelSuccess = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.GetModelSuccess', data);
        };
        Messages.GetModelSuccess.className = 'Vendd.ProductCompare.Messages.GetModelSuccess';

        Messages.GetWidgetModel = function () {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.GetWidgetModel');
        };
        Messages.GetWidgetModel.className = 'Vendd.ProductCompare.Messages.GetWidgetModel';

        Messages.GetWidgetModelSuccess = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.GetWidgetModelSuccess', data);
        };
        Messages.GetWidgetModelSuccess.className = 'Vendd.ProductCompare.Messages.GetWidgetModelSuccess';


        Messages.Failed = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.Failed', response);
        };
        Messages.Failed.className = 'Vendd.ProductCompare.Messages.Failed';

        Messages.ProductCompareAdded = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.ProductCompareAdded', response);
        };
        Messages.ProductCompareAdded.className = 'Vendd.ProductCompare.Messages.ProductCompareAdded';

        Messages.ProductCompareRemoved = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductCompare.Messages.ProductCompareRemoved', response);
        };
        Messages.ProductCompareRemoved.className = 'Vendd.ProductCompare.Messages.ProductCompareRemoved';

        return Messages;

    })(ProductCompare.Messages || {});

        return ProductCompare;

    })(Vendd.ProductCompare || {});

return Vendd;

})(Vendd || {});